// extracted by mini-css-extract-plugin
module.exports = {"container":"rd","hero":"sd","content":"td","typeProd":"ud","notTransparent":"vd","sliderDots":"wd","active":"xd"};